import { store } from '../../store'

export const saveVote = async ( vote: any ) => {

    let response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/2.0.0/cms/votes`, {
            body: JSON.stringify( {
                vote: vote
            } ),
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'POST'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'SAVE_VOTE_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'SAVE_VOTE_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'SAVE_VOTE_UNEXPECTEDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'SAVE_VOTE_OK' } )

}
